import React, { FunctionComponent, useState, useEffect } from 'react'
// @ts-ignore
import io from 'socket.io-client'
import { Button, Row, Col, Result } from 'antd'
import { APP } from 'Configs/App'

import Input from '../../ui/Input'

const SFATable: FunctionComponent = () => {
  const [token, setToken] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [result, setresult] = useState<string>('')

  const socket = io(`${APP.SOCKET_URL}`, {
    path: '/my-custom-path/',
  })

  useEffect(() => {
    socket.on('update-sfa', (data: string) => {
      setresult(data)
      setLoading(false)
    })
  }, [socket])

  const getToken = (val: string) => setToken(val)
  const updateMonthlyListeners = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    // const a = await action(token)
    if (token) {
      setLoading(true)
      socket.emit('update-sfa', {
        token,
        check_token: localStorage.getItem('access'),
      })
      setToken('')
    }
  }

  return (
    <>
      <Row gutter={64} align="middle">
        <Col className="gutter-row" span={12}>
          <Input
            value={token}
            placeholder="Paste Token"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              //  eslint-disable-next-line @typescript-eslint/no-explicit-any
              getToken(e.target.value)
            }
          />
        </Col>
        <Col className="gutter-row" span={3}>
          <Button
            type="primary"
            disabled={!token}
            loading={loading}
            onClick={updateMonthlyListeners}
          >
            Update Monthly Listeners
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          {result &&
            (result === 'Success' ? (
              <Result status="success" title="Successfully Updated Data!" />
            ) : (
              <Result title="The data dont updated" />
            ))}
        </Col>
      </Row>
    </>
  )
}

export default SFATable
